import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { ContentState } from "draft-js";

// Internal Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "../../../../../revvComponents";

// Internal Imports
import { DOCUMENTS } from "../../../../../constants";
import { checkTableDataSource } from "../../../../../utils/documentUtils";
import { evaluateFormula } from "../../../../../utils/tableFormulaUtils";
import { getContentStateFromRawSectionData } from "../../../../../utils/components";

// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class ManageColumnBtn extends Component {
  state = {};

  _showManageColumnsForTable = event => {
    event.preventDefault();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    this.props.preventEditorToDeactivate(false);
    const columnsHeaders = this._createColumnHeaders(this.props.component);
    this.props.showManageColumn(columnsHeaders, true, this.props.component);
  };

  _createColumnHeaders = section => {
    if (
      section &&
      section.data &&
      section.data.data &&
      section.data.data.length > 0
    ) {
      const firstRowData = section.data.data[0].data;
      const columnHeaders = [];
      const dataSource = checkTableDataSource(section);
      firstRowData.forEach((col, index) => {
        let colName = "";
        if (col.data.html || col.data) {
          const span = document.createElement("span");
          if (section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
            span.innerHTML = col.data.html;
          } else if (!dataSource && typeof col.data === "string") {
            span.innerHTML = col.data;
          } else if (!dataSource) {
            if (col.attributes.appliedFormula) {
              span.innerHTML = evaluateFormula(
                col.attributes.appliedFormula,
                section.data,
                this.props.mode,
              );
            } else {
              const rawData = col.data.data;
              let contentState = rawData;
              if (!(rawData instanceof ContentState)) {
                contentState = getContentStateFromRawSectionData(
                  { data: rawData },
                  this.props.mode,
                );
              }
              span.innerHTML = contentState ? contentState.getPlainText() : "";
            }
          } else if (
            dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE &&
            (typeof col.data === "string" || typeof col.data === "boolean")
          ) {
            span.innerHTML = col.data;
          } else if (dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE) {
            const rawData = col.data.data;
            let contentState = rawData;
            if (!(rawData instanceof ContentState)) {
              contentState = getContentStateFromRawSectionData(
                { data: rawData },
                this.props.mode,
              );
            }
            span.innerHTML = contentState ? contentState.getPlainText() : "";
          } else if (dataSource === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
            const rawData = col.data.data;
            let contentState = rawData;
            if (!(rawData instanceof ContentState)) {
              contentState = getContentStateFromRawSectionData(
                { data: rawData },
                this.props.mode,
              );
            }
            span.innerHTML = contentState ? contentState.getPlainText() : "";
          }
          colName = span.textContent || span.innerText;
        }
        let show = true;
        if (
          this.props.component &&
          this.props.component.data &&
          this.props.component.data.attributes &&
          this.props.component.data.attributes.hiddenCols &&
          this.props.component.data.attributes.hiddenCols.includes(index)
        ) {
          show = false;
        }
        const colHeader = { id: index, name: colName, show };
        columnHeaders.push(colHeader);
      });
      return columnHeaders;
    }
    return [];
  };

  _showManageColumnOption = () => (
    // check if there is any focus column or not
    // if (focusColumnID === undefined || focusColumnID === null || !tableData) {
    //   return null;
    // }
    // if (data[focusRowID] === null || data[focusRowID] === undefined) {
    //   return null;
    // }
    <div className="managecol-table">
      <Fragment>
        <Tooltip
          placement="bottom"
          overlay="Manage table columns"
          align={{
            offset: [0, 3],
          }}>
          <div
            className={`managecol-table-items ${
              this.props.selectedRowId === null &&
              this.props.selectedColumnId !== null
                ? "disabled-options"
                : ""
            }`}>
            <Button
              data-test="change-form-vew"
              className="btn btn-transparent-header"
              onMouseDown={event => {
                this._showManageColumnsForTable(event);
              }}>
              <i>
                <FontAwesomeIcon icon={["far", "columns"]} />
              </i>
              Manage Columns
            </Button>
          </div>
        </Tooltip>
      </Fragment>
    </div>
  );

  render() {
    return <Fragment>{this._showManageColumnOption()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta } = state.DocumentStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId } = activeComponentMeta;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined && focusColumnID !== undefined
      ? [focusRowID, focusColumnID]
      : null;

  return {
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
  };
};

export default connect(mapStateToProps, null)(ManageColumnBtn);
